import React from 'react'
const Loader = () => {
  return (
    <div id='loader' className='hidden'
    >
      <div i className="custom-loader-overlay">
        <div className="logo_container_loader">
          <img
            src="/images/driver_rescue_black_logo.png"
            alt="Loading..."
            className="logo-img-loader"
          />
          <div className="shimmer-mask" />
        </div>
      </div>
    </div>

  )
}

export default Loader
